import { SignupButton } from '../../designsystem/SignupButton'
import { Marketing } from '../../designsystem/Text'

export function CTASection() {
  return (
    <div className='px-6 space-y-4 text-left bg-white sm:px-10 py-36 -mb-36 sm:text-center'>
      <Marketing.H2>What are you waiting for?</Marketing.H2>
      <p className='max-w-xl mx-auto text-lg font-medium sm:text-2xl gotham text-gray opacity-60'>
        It takes less than 5 minutes to create a GraphCDN service for your
        GraphQL API. No credit card required!
      </p>
      <SignupButton />
    </div>
  )
}
